export const PrimaryColor = "#949494";
export const SecondaryColor = "#FF2E57";

export const DefaultTheme = {
  primaryColor: PrimaryColor,
  secondaryColor: SecondaryColor,
};
